<div class="pc-row" [formGroup]="projectItemForm">
  <div class="pc-radio">
    <input class="with-gap" type="radio" name="primarypc"
      [value]="projectItemForm.controls.id.value"
      [checked]="currentItem == projectItemForm.controls.id.value"
      [attr.disabled]="readOnly ? '' : null"
      (change)="onItemSelectionChange(projectItemForm)"
      id="{{ 'primarypc' + current }}">
    <label attr.for="{{ 'primarypc' + current }}" matTooltip="mark as primary production contact" matTooltipPosition="above"></label>
  </div>
  <div class="pc-fields">
    <mat-form-field appearance="fill">
      <mat-label>Production Contact Title</mat-label>
      <input matInput formControlName="title" type="text" maxlength="30">
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Contact Full name</mat-label>
      <input matInput formControlName="name" type="text" maxlength="80">
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Contact Email</mat-label>
      <input matInput formControlName="email" type="email" maxlength="50">
      <mat-error *ngIf="displayMessage.email">{{ displayMessage.email }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Contact Phone number</mat-label>
      <input matInput formControlName="phoneNumber" type="tel" maxlength="20">
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Office Phone number</mat-label>
      <input matInput formControlName="phoneNumber2" type="tel" maxlength="20">
    </mat-form-field>
    <div class="pc-phone-row">
      <mat-form-field appearance="fill" class="pc-phone-field">
        <mat-label>Other Phone number</mat-label>
        <input matInput formControlName="phoneNumber3" type="tel" maxlength="20">
      </mat-form-field>
      <div class="pc-actions" *ngIf="!readOnly">
        <button mat-icon-button *ngIf="current + 1 == count; else elseBlock"
          (click)="addProjectItem()" matTooltip="add another production contact" matTooltipPosition="below">
          <mat-icon>add</mat-icon>
        </button>
        <ng-template #elseBlock>
          <button mat-icon-button (click)="removeProjectItem(current)"
            matTooltip="remove production contact" matTooltipPosition="below">
            <mat-icon>remove</mat-icon>
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
